module.exports = __webpack_public_path__ + "img/32-openoffice.46257aaf.png";